import React from "react"
import { Dialog } from '@headlessui/react'
import { LinkIcon } from '@heroicons/react/solid'

const SecureSavings = (props) => {
  return (
    <div>
      <div className="mt-4 text-center">
        <Dialog.Title
          as="h3"
          className="text-md leading-7 font-primary font-bold text-convoy-section-title xl:text-xl"
        >
          Request received!
        </Dialog.Title>
        <div className="mt-3">
          <p className="font-primary text-xxs leading-5 text-grey-footer xl:text-xs">
            We'll be in touch about any discount we can negotiate for you.
          </p>
        </div>

        <div className="mt-3">
          <button
            type="button"
            className="text-xs inline-flex justify-center w-full rounded-100 border border-transparent text-center font-black font-primary text-grey-buttonText focus:outline-none py-4 bg-blue-800 leading-buttonText hover:bg-blue-buttonHover"
            onClick={() => {
              props.submitAction();
            }}
          >
            Make another request
          </button>
        </div>

      </div>
    </div>
  );
};

export default SecureSavings;